<template>
  <PageHeaderLayout>
    <div class="main-page-content profile-edit-page">
      <div class="profile-edit-shell">
        <section class="profile-edit-header">
          <div class="profile-title-group">
            <span class="profile-kicker">账号设置</span>
            <h1>修改个人信息</h1>
            <p>{{ profileMeta }}</p>
          </div>
          <div class="profile-identity">
            <div class="profile-avatar">
              <img v-if="profileAvatar" :src="profileAvatar" alt="头像">
              <span v-else>{{ profileInitial }}</span>
            </div>
            <div class="profile-identity-text">
              <strong>{{ profileName }}</strong>
              <span>{{ user.email || '未填写邮箱' }}</span>
            </div>
          </div>
        </section>

        <div class="profile-edit-layout">
          <aside class="profile-aside">
            <div class="profile-aside-card">
              <div class="aside-avatar">
                <img v-if="profileAvatar" :src="profileAvatar" alt="头像">
                <span v-else>{{ profileInitial }}</span>
              </div>
              <div class="aside-name">{{ profileName }}</div>
              <div class="aside-subtitle">{{ user.mobile || '未填写手机号' }}</div>
            </div>
            <div class="profile-info-list">
              <div class="profile-info-item">
                <span>真实姓名</span>
                <strong>{{ user.name || '-' }}</strong>
              </div>
              <div class="profile-info-item">
                <span>用户昵称</span>
                <strong>{{ user.nickname || '-' }}</strong>
              </div>
              <div class="profile-info-item">
                <span>手机号码</span>
                <strong>{{ user.mobile || '-' }}</strong>
              </div>
            </div>
          </aside>

          <section class="profile-editor-panel">
            <el-tabs v-model="activeTab" class="profile-tabs">
              <el-tab-pane label="基本资料" name="userinfo">
                <UserInfo :user.sync="user"/>
              </el-tab-pane>
              <el-tab-pane label="修改密码" name="resetPwd">
                <ResetPwd/>
              </el-tab-pane>
              <el-tab-pane label="权限申请" name="permissions">
                <RoleApplyPanel/>
              </el-tab-pane>
            </el-tabs>
          </section>
        </div>
      </div>
    </div>
  </PageHeaderLayout>
</template>

<script>
import {mapGetters} from 'vuex'
import ResetPwd from '@/pages/user/profile/ResetPwd'
import UserInfo from '@/pages/user/profile/UserInfo'
import RoleApplyPanel from '@/pages/user/components/RoleApplyPanel.vue'
import PageHeaderLayout from "@/layouts/PageHeaderLayout.vue";

export default {
  name: 'UserProfileUserProfile',
  data() {
    return {
      activeTab: 'userinfo',
      user: {}

    }
  },
  components: {PageHeaderLayout, ResetPwd, UserInfo, RoleApplyPanel },
  computed: {
    ...mapGetters(['userInfo']),
    profileName() {
      return this.user.name || this.user.nickname || '当前账号'
    },
    profileAvatar() {
      return this.userInfo.avatar || this.user.avatar || ''
    },
    profileInitial() {
      return String(this.profileName || '-').trim().charAt(0).toUpperCase()
    },
    profileMeta() {
      const mobile = this.user.mobile || '未填写手机号'
      const email = this.user.email || '未填写邮箱'
      return `${mobile} · ${email}`
    }
  },
  methods: {
    async getUser() {
      const { user } = await this.$api.getUserProfile()
      this.user = user
      if (user.avatar) this.userAvatar = user.avatar
    }
  },
  created() {
    this.getUser()
  }
}
</script>

<style scoped>
.profile-edit-page {
  min-height: 100%;
  padding: 22px;
  background: #f5f7fb;
  box-sizing: border-box;
}

.profile-edit-shell {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.profile-edit-header {
  min-height: 112px;
  padding: 22px 26px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.profile-kicker {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  font-size: 12px;
  line-height: 24px;
}

.profile-title-group h1 {
  margin: 10px 0 6px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.profile-title-group p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.profile-identity {
  min-width: 260px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.profile-avatar,
.aside-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  color: #ffffff;
  background: #2f7cf6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  overflow: hidden;
}

.profile-avatar img,
.aside-avatar img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.profile-identity-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile-identity-text strong {
  color: #1f2937;
  font-size: 15px;
  line-height: 20px;
}

.profile-identity-text span {
  max-width: 180px;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-edit-layout {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 14px;
  align-items: flex-start;
}

.profile-aside,
.profile-editor-panel {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.profile-aside {
  overflow: hidden;
}

.profile-aside-card {
  padding: 26px 18px 22px;
  border-bottom: 1px solid #edf1f6;
  text-align: center;
}

.aside-avatar {
  width: 68px;
  height: 68px;
  margin: 0 auto 12px;
  background: #14b8a6;
  font-size: 26px;
}

.aside-name {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
}

.aside-subtitle {
  margin-top: 4px;
  color: #8a94a6;
  font-size: 13px;
  line-height: 20px;
}

.profile-info-list {
  padding: 8px 18px 18px;
}

.profile-info-item {
  padding: 13px 0;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.profile-info-item:last-child {
  border-bottom: 0;
}

.profile-info-item span {
  color: #7a8494;
  font-size: 13px;
}

.profile-info-item strong {
  min-width: 0;
  color: #263142;
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-editor-panel {
  min-width: 0;
  min-height: 470px;
  padding: 0 24px 24px;
}

.profile-tabs ::v-deep .el-tabs__header {
  margin: 0;
  padding-top: 8px;
}

.profile-tabs ::v-deep .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #edf1f6;
}

.profile-tabs ::v-deep .el-tabs__item {
  height: 48px;
  color: #667085;
  font-size: 14px;
  line-height: 48px;
}

.profile-tabs ::v-deep .el-tabs__item.is-active {
  color: #ff3176;
  font-weight: 600;
}

.profile-tabs ::v-deep .el-tabs__active-bar {
  height: 3px;
  background-color: #ff3176;
}

.profile-tabs ::v-deep .el-tabs__content {
  padding-top: 24px;
}

@media (max-width: 1080px) {
  .profile-edit-layout {
    grid-template-columns: 1fr;
  }

  .profile-aside {
    display: none;
  }
}

@media (max-width: 720px) {
  .profile-edit-page {
    padding: 12px;
  }

  .profile-edit-header {
    padding: 18px;
    align-items: flex-start;
    flex-direction: column;
  }

  .profile-identity {
    width: 100%;
    min-width: 0;
  }

  .profile-editor-panel {
    padding: 0 16px 18px;
  }
}
</style>
